import { render, staticRenderFns } from "./CustomsInvoicePictureView.vue?vue&type=template&id=86cac2c8&scoped=true&"
import script from "./CustomsInvoicePictureView.vue?vue&type=script&lang=ts&"
export * from "./CustomsInvoicePictureView.vue?vue&type=script&lang=ts&"
import style0 from "./CustomsInvoicePictureView.vue?vue&type=style&index=0&id=86cac2c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86cac2c8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCol,VDivider,VExpandTransition,VRow,VTextField,VTooltip})
